module.exports = __webpack_public_path__ + "img/nayan_video_thumbnail.14f28700.jpg";